export default __webpack_public_path__ + "static/media/AdvertiseImg_1.2772f27d.jpg";